import { isEntityAccount } from "$lib/util/account"
import { LIQUIDITY_NEEDS } from "@tastyworks/shared-utils/misc/constants"
import {
  ACCOUNT_ACTIVITY_TYPES,
  ACCOUNT_TYPE_CHOICES,
  EXPECTED_WITHDRAWAL_TYPES,
  INITIAL_DEPOSIT_TYPES,
  INITIAL_FUNDING_SOURCE,
  REFERRAL_SOURCES,
} from "@tastyworks/tastyworks-api"
import { Schema, boolean, mixed, number, object, string } from "yup"

function isPersonalReferral(
  [initialContact]: REFERRAL_SOURCES[],
  schema: Schema
) {
  return initialContact === REFERRAL_SOURCES.PERSONAL_REFERRAL
    ? schema.required()
    : schema
}

export const accountActivityBankingSchema = object({
  accountType: mixed<ACCOUNT_TYPE_CHOICES>(),
  primaryBanking: string().required(),
  valueInitialDeposit: number()
    .typeError("Must be a number")
    .positive()
    .required(),
  initialDepositType: mixed<INITIAL_DEPOSIT_TYPES>()
    .oneOf(Object.values(INITIAL_DEPOSIT_TYPES))
    .required(),
  initialFundingSource: mixed<INITIAL_FUNDING_SOURCE>()
    .oneOf(Object.values(INITIAL_FUNDING_SOURCE))
    .when("accountType", ([accountType], schema) =>
      isEntityAccount(accountType) ? schema.required() : schema.nullable()
    ),
})

export const accountActivityDetailsSchema = object({
  isForeigner: boolean(),
  accountActivityType: mixed<ACCOUNT_ACTIVITY_TYPES>()
    .oneOf(Object.values(ACCOUNT_ACTIVITY_TYPES))
    .required(),
  liquidityNeeds: mixed<LIQUIDITY_NEEDS>()
    .oneOf(Object.values(LIQUIDITY_NEEDS))
    .required(),
  expectedWithdrawals: mixed<EXPECTED_WITHDRAWAL_TYPES>()
    .oneOf(Object.values(EXPECTED_WITHDRAWAL_TYPES))
    .required(),
  initialContact: mixed<REFERRAL_SOURCES>()
    .oneOf(Object.values(REFERRAL_SOURCES))
    .when("isForeigner", ([isForeigner], schema) =>
      isForeigner ? schema.required() : schema.nullable()
    ),
  referredName: string().when("initialContact", isPersonalReferral),
  referredRelationship: string().when("initialContact", isPersonalReferral),
  isReferredToBroker: boolean().required(),
})

export const accountActivitySchema = object({
  bankingInformation: accountActivityBankingSchema,
  accountActivityDetails: accountActivityDetailsSchema,
})
